"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* globals module */
/**
 * @module settingsRoute
 * @description Baasic Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Settings Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
var contracts_1 = require("../../../core/contracts");
var SettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(SettingsRoute, _super);
    function SettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
         * Settings route with route and query parameters.
         **/
        _this.getRoute = 'settings';
        /**
         * Settings route with route and query parameters.
         **/
        _this.updateRoute = 'settings';
        return _this;
    }
    /**
     * Parses get version route.
     * @method
     * @example versionRoute.get()
     **/
    SettingsRoute.prototype.get = function () {
        return _super.prototype.baseGet.call(this, this.getRoute);
    };
    /**
     * Parses update settings route.
     * @method
     * @param data A settings object used to update specified settings resource.
     * @example settingsRoute.update(data);
     */
    SettingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    SettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], SettingsRoute);
    return SettingsRoute;
}(common_1.BaseRoute));
exports.SettingsRoute = SettingsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 
